export const ADD_MULTI_ORDER = 'ADD_MULTI_ORDER';
export const ADD_MULTI_ORDER_ITEM = 'ADD_MULTI_ORDER_ITEM';
export const MULTI_ORDER_ERROR = 'MULTI_ORDER_ERROR';
export const MULTI_ORDER_ERROR_RESET = 'MULTI_ORDER_ERROR_RESET';
export const RECEIVE_MULTI_ORDER_ENABLED = 'RECEIVE_MULTI_ORDER_ENABLED';

export const addMultiOrder = (order) => ({ type: ADD_MULTI_ORDER, payload: order });

export const multiOrderError = (error) => ({
  type: MULTI_ORDER_ERROR,
  payload: error,
});

export const multiOrderErrorReset = () => ({
  type: MULTI_ORDER_ERROR_RESET,
});

export const addMultiOrderItem = (item) => ({
  type: ADD_MULTI_ORDER_ITEM,
  payload: item,
});

export const receiveMultiOrderFlag = (enabled) => ({
  type: RECEIVE_MULTI_ORDER_ENABLED,
  payload: enabled,
});
